import clsx from "clsx";
import { useMemo } from "react";
import ReactMarkdown, { Components } from "react-markdown";

const defaultAdditionalComponents = {};
export function MarkdownRenderer({
  children,
  className,
  textColor,
  isMobile,
  bgColor,
  additionalComponents = defaultAdditionalComponents,
}: {
  textColor: string;
  bgColor?: string;
  className?: string;
  isMobile?: boolean;
  children: string;
  additionalComponents?: Partial<Components>;
}) {
  const components = useMemo(() => {
    return getComponents({ textColor, bgColor, isMobile });
  }, [textColor, bgColor, isMobile]);

  return (
    <ReactMarkdown
      className={clsx(
        typeof className !== "undefined"
          ? className
          : "whitespace-pre-wrap grid"
      )}
      components={{ ...components, ...additionalComponents }}
    >
      {children}
    </ReactMarkdown>
  );
}
// const fontFamily = `-apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Apple Color Emoji', Helvetica, Arial, sans-serif`;

const baseTextStyles: React.CSSProperties = {
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Apple Color Emoji', Helvetica, Arial, sans-serif`,
  padding: "8px 24px",
  marginBlockStart: 0,
  marginBlockEnd: 0,
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "28px",
};

const getComponents = ({
  textColor,
  bgColor,
  isMobile,
}: {
  textColor: string;
  bgColor?: string;
  isMobile?: boolean;
}) => {
  //   const cardLinkTextColor = theme.cardLinkTextColor.value;

  return {
    img: ({ ...props }) => {
      return null;
      //   return (
      //   <img
      //     css={`
      //       display: block;
      //       width: 100%;
      //       height: auto;
      //       max-width: 100%;
      //     `}
      //     {...props}
      //   />
      // )
    },
    h1: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    h2: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    h3: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    h4: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    h5: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    h6: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    a: ({ node, ...props }: any) => (
      <a
        rel="nofollow noopener noreferrer"
        target="_blank"
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
        // css={`
        //   ${textStyles}

        //   color: ${cardLinkTextColor};
        //   :visited {
        //     color: ${cardLinkTextColor};
        //   }
        // `}
      />
    ),
    u: ({ node, ...props }: any) => (
      <u
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    p: ({ node, ...props }: any) => (
      <p
        style={{
          ...baseTextStyles,
          padding: isMobile ? "0 8px" : "8px 24px",
          color: textColor,
          backgroundColor: bgColor,
        }}
        {...props}
      />
    ),
    ol: ({ node, ...props }: any) => (
      <ol
        style={{
          ...baseTextStyles,
          paddingLeft: 16,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
          lineHeight: 1,
          listStyleType: "decimal",
          textAlign: "left",
        }}
        // className="list-decimal text-left"
      >
        {props.children}
      </ol>
    ),

    ul: ({ node, ...props }: any) => (
      <ul
        style={{
          ...baseTextStyles,
          paddingLeft: 16,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
          lineHeight: 1,
          listStyleType: "disc",
          textAlign: "left",
        }}
      >
        {props.children}
      </ul>
    ),
    li: ({ node, ...props }: any) => (
      <li
        style={{
          ...baseTextStyles,
          color: textColor,
          backgroundColor: bgColor,
        }}
        className=""
        {...props}
      />
    ),
  };
};
